import {Component, forwardRef, Input, OnInit} from '@angular/core';
import {
  ControlValueAccessor,
  UntypedFormArray,
  UntypedFormControl,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {IDropdownObject} from 'src/app/interfaces/dropdown-object.interface';

@UntilDestroy()
@Component({
  selector: 'app-filter-multi-select',
  templateUrl: './filter-multi-select.component.html',
  styleUrls: ['./filter-multi-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FilterMultiSelectComponent),
      multi: true,
    },
  ],
})
/**
 * This component consist with custom dropdown with input title and list of checkbox with labels from input selectArr array.
 * When user select/unselect checkbox its label pushes/delete from the array and emit to father component based on controlValueAccessor technology
 */
export class FilterMultiSelectComponent
  implements OnInit, ControlValueAccessor
{
  /**
   * checkbox label list
   */
  @Input() selectArr: IDropdownObject[] | null = [];

  /**
   * title of multi-select element
   */
  @Input() title = ' ';

  /**
   * define show or hide multi-select element
   */
  showHideObj = false;
  selectedCheckboxes: any = {};

  onChange: any;
  onTouched: any;

  selectArrControl = new UntypedFormArray([]);
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(value: IDropdownObject[] | null): void {
    if (value) {
      for (const item of value) {
        const obj = this.selectArr?.find(v => v.id === item.id);
        if (obj) {
          this.selectArrControl.push(new UntypedFormControl(obj));
          this.selectedCheckboxes[obj.name] = true;
        }
      }
    } else {
      this.clearFilter();
    }
  }

  /**
   * On change select checkbox will emit array with selected values
   */
  ngOnInit(): void {
    this.clearCheckboxes();
    this.selectArrControl.valueChanges
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        if (this.onChange) {
          this.onChange(
            this.selectArrControl.value?.length
              ? this.selectArrControl.value
              : null
          );
        }
      });
  }

  /**
   * This function called when changed select of checkbox. If it was checked - checkbox label will push to the selectArrControl
   * if unchecked will remove this item from the array
   *
   * @param { string } item - selected/unselected checkbox label
   * @param { Event } e
   */
  onChangeCheckbox(item: IDropdownObject, e: Event) {
    if ((e.target as HTMLInputElement).checked) {
      this.selectArrControl.push(new UntypedFormControl(item));
    } else {
      const index = this.selectArrControl.controls.findIndex(
        ind => ind.value == item
      );
      this.selectArrControl.removeAt(index);
    }
  }

  clearCheckboxes(): void {
    for (const item of this.selectArr || []) {
      this.selectedCheckboxes[item.name] = false;
    }
  }

  clearFilter(): void {
    this.clearCheckboxes();
    this.selectArrControl.clear();
  }
}
